import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import _map from 'lodash/map';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import { PlatformType } from '../../../app/types';
import { platformIconsSrc } from '../../../app/utils';
import Checkbox from '../../shared/Checkbox';
import RowTitle from '../RowTitle';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    statusLabel: {
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: 1,
      color: color.$3,
    },
    icon: {
      width: 20,
      height: 20,
      marginRight: 4,
    },
    platformLabel: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  {
    name: 'Platforms',
  },
);

const Platforms = ({
  platforms = [],
  integration = [],
  onChange,
  disabled,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathKey } = useSelector(store => store.aiBot);
  const { perm } = useSelector(store => store.organization);

  const tempPlatformTypes = useMemo(() => {
    if (perm?.plan_id === 'xFreeV3') {
      return [PlatformType.LIVECHAT];
    }
    if (perm?.plan_id === 'xBasicV3') {
      return [
        PlatformType.LIVECHAT,
        PlatformType.LINE,
        PlatformType.FACEBOOK,
        PlatformType.INSTAGRAM,
      ];
    }
    return PlatformType;
  }, [perm]);

  const checkBoxComponents = _map(tempPlatformTypes, value => {
    const isDisabled =
      !integration.find(i => i?.platform?.objectId === value) || disabled;
    return (
      <FormControlLabel
        key={`Platform-${value}`}
        disabled={isDisabled}
        control={
          <Checkbox
            checked={!!platforms.find(s => s === value)}
            onChange={e => {
              if (e.target.checked) {
                onChange({
                  platforms: [...platforms, value],
                });
              } else if (platforms.length > 1) {
                onChange({
                  platforms: platforms.filter(s => s !== value),
                });
              }
            }}
            name={value}
            color="primary"
          />
        }
        label={
          <div className={classes.platformLabel}>
            <img
              style={{
                opacity: isDisabled ? 0.3 : 1,
              }}
              src={platformIconsSrc[value]}
              className={classes.icon}
              alt={value}
            />
            <span
              className={classes.statusLabel}
              style={{
                color: isDisabled ? color.$10 : color.$3,
              }}
            >
              {t(`platform.${value}`)}
            </span>
          </div>
        }
      />
    );
  });

  return (
    <div className={classes.root}>
      <RowTitle
        title={t(`${pathKey}:basicSettingContainer.platforms`)}
        isRequired
      />
      {checkBoxComponents}
    </div>
  );
};

export default Platforms;
